/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import {
  createAPIAction,
  createResetAPIAction,
} from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('reigster', [
  'captcha',
  'checkEmail',
]);

function captcha() {
  return createAPIAction(
    types.captcha,
    {
      endpoint: '/authentication/captcha',
    })();
}

function checkEmail(email) {
  return createAPIAction(
    types.checkEmail,
    {
      endpoint: '/check/email',
      body: {
        email,
      },
      method: 'POST',
    })();
}

function resetCheckEmail() {
  return createResetAPIAction(types.checkEmail)();
}

export default {
  types,
  captcha,
  checkEmail,
  resetCheckEmail,
};




// WEBPACK FOOTER //
// ./src/redux/actions/register.js